import { render, staticRenderFns } from "./ResolvedTasksList.vue?vue&type=template&id=191cd017"
import script from "./ResolvedTasksList.vue?vue&type=script&lang=js"
export * from "./ResolvedTasksList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports